import type { OrganizationType } from '@mntn-dev/domain-types'
import type {
  PrivilegeKey,
  PrivilegeModel,
  RoleKey,
  RoleModel,
} from '../models.ts'
import type { Permission } from '../types/permissions.ts'
import {
  AgencyPrivilege,
  AllPrivilege,
  BrandPrivilege,
  CorePrivilege,
  InternalPrivilege,
  OrganizationAdminPrivilege,
} from './privilege.ts'
import {
  AgencyRole,
  BrandRole,
  InternalRole,
  OrganizationAdminRole,
  SystemRole,
} from './roles.ts'

export const OrganizationTypeToRoleMap: Record<OrganizationType, RoleModel> = {
  brand: BrandRole,
  agency: AgencyRole,
  internal: InternalRole,
}

export const RoleMap: Record<RoleKey, RoleModel> = {
  brand: BrandRole,
  agency: AgencyRole,
  internal: InternalRole,
  'organization-admin': OrganizationAdminRole,
  system: SystemRole,
}

export const PrivilegeMap: Record<PrivilegeKey, PrivilegeModel> = {
  core: CorePrivilege,
  'organization-admin': OrganizationAdminPrivilege,
  brand: BrandPrivilege,
  agency: AgencyPrivilege,
  internal: InternalPrivilege,
  all: AllPrivilege,
}

export const getPrivileges = (
  organizationType: OrganizationType,
  roleKeys: RoleKey[] = []
): PrivilegeKey[] => {
  const organizationPrivileges = new Set(
    OrganizationTypeToRoleMap[organizationType].privileges
  )
  const rolePrivileges = new Set(
    roleKeys.flatMap((key) => RoleMap[key].privileges)
  )
  return Array.from(organizationPrivileges.union(rolePrivileges))
}

export const getPermissions = (privilegeKeys: PrivilegeKey[]) =>
  Array.from(
    new Set(privilegeKeys.flatMap((key) => PrivilegeMap[key].permissions))
  )

export const hasPermission = (
  principal: { permissions: Permission[] },
  permission: Permission
) => principal.permissions.includes(permission)

export const hydratePermissions = (principal: {
  privileges: PrivilegeKey[]
}) => ({ ...principal, permissions: getPermissions(principal.privileges) })
